import React, { useState, useEffect } from 'react';
import {
  Stack,
  Breadcrumb,
  Divider,
  Container,
  Checkbox,
  Nav,
  Panel,
  FlexboxGrid,
  Col,
  Button,
  Input,
  Message,
  useToaster,
  Toggle,
  Table,
  SelectPicker
} from 'rsuite';
import globalIP from '@/GlobelIP';
import MenuIcon from '@rsuite/icons/Menu';
import { Link } from 'react-router-dom';
import ugr from '@/UGRoute';

const { Column, HeaderCell, Cell } = Table;

function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
}

const MasterAttri = () => {
  const ip = globalIP;
  const [activeKey, setActiveKey] = useState('content1');
  const handleNavSelect = eventKey => {
    setActiveKey(eventKey);
  };
  const [tableHeight, setTableHeight] = useState(20); // Default height

  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 320; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };

    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize

    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  //////// catalogue Attributes Start ////////
  const [headsData, setHeadsData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [status, setStatus] = useState(false);
  useEffect(() => {
    fetchDataHeads();
  }, []);
  const fetchDataHeads = async () => {
    const response = await fetch(
      `${ip}/api/product-attributes?filters[Industry][$eq]=Furniture&sort[0]=id`
    );
    const json = await response.json();

    setHeadsData(json.data);
  };
  const filteredHeadsData = headsData.filter(head => {
    if (status) {
      return head.attributes.Heads !== 'size';
    } else {
      return head.attributes.Heads !== 'sizerange';
    }
  });

  const [fheadsData, setFHeadsData] = useState([]);
  const [checkedCount, setCheckedCount] = useState(0);

  useEffect(() => {
    fetchDataHeadsF();
  }, []);
  useEffect(() => {
    if (headsData.length > 0) {
      const allChecked = headsData.every(head => head.attributes.status);
      setSelectAll(allChecked);
    }
  }, [headsData]);
  const fetchDataHeadsF = async () => {
    const response = await fetch(`${ip}/api/mstfilters?populate=*&sort[0]=id`);
    const json = await response.json();
    setFHeadsData(json.data);
    const filteredData = json.data.filter(item => item.attributes.filterstatus === true);
    setCheckedCount(filteredData.length);
  };

  const updateHeadStatus = async (headId, newStatus) => {
    try {
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          status: newStatus
        })
      );
      await fetch(`${ip}/api/product-attributes/${headId}`, {
        method: 'PUT',
        body: formData
      });
      fetchDataHeads();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  const handleCheckboxChange = async (headId, currentStatus) => {
    try {
      const updatedStatus = !currentStatus; // Toggle the status
      await updateHeadStatus(headId, updatedStatus);
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  const handleSelectAllChange = async () => {
    try {
      // Update status of all checkboxes based on selectAll state
      const updatedStatus = !selectAll;
      await Promise.all(
        headsData.map(async head => {
          await updateHeadStatus(head.id, updatedStatus);
        })
      );
      setSelectAll(updatedStatus);
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const [label1, setLabel1] = useState([]);
  const displayLabels = {
    aliascd: `${label1[0]?.attributes.AliasCode}`,
    productname: `${label1[0]?.attributes.ProductName}`,
    description: `${label1[0]?.attributes.Description}`,
    prodtypecd: `${label1[0]?.attributes.ProductType}`,
    catcd: `${label1[0]?.attributes.Category}`,
    finish: `${label1[0]?.attributes.finish}`,
    color: `${label1[0]?.attributes.color}`,
    netwgt: `${label1[0]?.attributes.NetWgt}`,
    grswgt: `${label1[0]?.attributes.GrossWgt}`,
    saleprice: `${label1[0]?.attributes.SalePrice}`,
    cbm: `${label1[0]?.attributes.cbm}`,
    size: `${label1[0]?.attributes.Sizeunit}`,
    sizerange: `${label1[0]?.attributes.SizeRange}`,
    material: `${label1[0]?.attributes.MaterialName}`,
    innmaster: `Inner/Master`,
    moq: `${label1[0]?.attributes.MOQ}`,
    currency: `${label1[0]?.attributes.Currency}`,
    remark: `${label1[0]?.attributes.ProductRemark}`,
    ptech: `${label1[0]?.attributes.P_Technique}`,
    madeby: `${label1[0]?.attributes.MadeBy}`,
  };
  const displayLabels1 = {
    AliasCode: `${label1[0]?.attributes.AliasCode}`,
    ProName: `${label1[0]?.attributes.ProductName}`,
    ProductType: `${label1[0]?.attributes.ProductType}`,
    Category: `${label1[0]?.attributes.Category}`,
    Finish: `${label1[0]?.attributes.finish}`,
    Color: `${label1[0]?.attributes.color}`,
    BuyerName: `${label1[0]?.attributes.BuyerName}`,
    BuyerStyle: `${label1[0]?.attributes.BuyerSku}`,
    Searchk: `${label1[0]?.attributes.searchKeyword}`,
    PDesign: `${label1[0]?.attributes.ProductDesigner}`,
    MadeBy: `${label1[0]?.attributes.MadeBy}`,
    HSN: `${label1[0]?.attributes.HSN}`,
    MaterialName: `${label1[0]?.attributes.MaterialName}`,
    CreateOn: `${label1[0]?.attributes.addon}`,
    UpdateOn: `${label1[0]?.attributes.updateon}`,

  };
  //////// catalogue Attributes End ////////

  //////// Filter Attributes Start ////////
  const handleCheckboxChange1 = async (headId, currentStatus) => {
    try {
      const updatedStatus = !currentStatus; // Toggle the status
      await updateHeadStatus1(headId, updatedStatus);
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  const updateHeadStatus1 = async (headId, newStatus) => {
    try {
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          filterstatus: newStatus
        })
      );
      await fetch(`${ip}/api/mstfilters/${headId}`, {
        method: 'PUT',
        body: formData
      });
      fetchDataHeadsF();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  //////// Filter Attributes End ////////

  //////// Product Register Attributes Start ////////
  const [label, setLabel] = useState({
    Category: '',
    ProductType: '',
    AliasCode: '',
    ProductName: '',
    Description: '',
    Sizeunit: '',
    length: '',
    width: '',
    height: '',
    cbm: '',
    finish: '',
    color: '',
    HSN: '',
    NetWgt: '',
    GrossWgt: '',
    MOQ: '',
    Currency: '',
    CurRate: '',
    SalePrice: '',
    SalePriceINR: '',
    ProductDesigner: '',
    MadeBy: '',
    ProductRemark: '',
    searchKeyword: '',
    BuyerName: '',
    BuyerSku: '',
    BuyerRemark: '',
    MaterialName: '',
    Shape: '',
    Collection: '',
    Season: '',
    P_Technique: '',
    SizeRange: ''
  });
  const [isEditing, setIsEditing] = useState(false);
  const [labelId, setLabelID] = useState(null);
  const [fetchedLabels, setFetchedLabels] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel1(json.data);
      const extractedData = json.data[0].attributes;
      setLabel(extractedData);
      setLabelID(json.data[0]?.id);
      setFetchedLabels(json.data || []);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleEditClick = () => {
    setIsEditing(prevState => !prevState);
  };

  const handleInputChange = (fieldName, value) => {
    setLabel(prevState => ({
      ...prevState,
      [fieldName]: value
    }));
  };
  const toaster = useToaster();
  const handleSave = async () => {
    try {
      // Trim and check if any field is empty
      const trimmedLabel = Object.fromEntries(
        Object.entries(label).map(([key, value]) => [key, value.trim()])
      );
      const isEmpty = Object.values(trimmedLabel).some(value => value === '');
      if (isEmpty) {
        toaster.push(
          <Message showIcon type="error">
            Please fill all fields.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Exit the function early if any field is empty
      }
      // Check for duplicate values in a case-insensitive manner
      const lowercaseValues = Object.values(trimmedLabel).map(value => value.toLowerCase());
      const valueOccurrences = lowercaseValues.reduce((acc, value) => {
        acc[value] = (acc[value] || 0) + 1;
        return acc;
      }, {});
      const hasDuplicates = Object.values(valueOccurrences).some(count => count > 1);
      if (hasDuplicates) {
        toaster.push(
          <Message showIcon type="error">
            Duplicate values detected! Please ensure all fields are unique.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Exit the function if duplicates are found
      }
      // Perform the save operation if validation passes
      const response = await fetch(`${ip}/api/product-labels/${labelId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: trimmedLabel })
      });

      if (response.ok) {
        // If the API call is successful, update the data
        fetchDatalabel();
        toaster.push(
          <Message showIcon type="success">
            Saved Changes.
          </Message>,
          { placement: 'topEnd' }
        );
        setIsEditing(false); // Exit editing mode after saving
      }
    } catch (error) {
      console.error('Error updating label:', error);
    }
  };
  const excludedFields = ['createdAt', 'updatedAt', 'publishedAt'];
  const attributes = Object.entries(label)
    .filter(([key]) => !excludedFields.includes(key))
    .map(([key, value]) => ({
      attribute: key,
      value: value
    }));

  // const [dada, setData] = useState({
  //     Heads: 'aliascd',
  //     Industry: 'Furniture',
  //     status: 'false',
  //     Filterstatus: 'true'
  // })
  // const hsndleds = async () => {
  //     const formdata=new FormData();
  //     formdata.append('data',JSON.stringify(dada))
  //     const response = await fetch(`${ip}/api/product-attributes/3`, {
  //         method: 'PUT',
  //         body: formdata, // Assuming you only need to update the Category field
  //     });
  //     if (response.ok) {
  //         // If the API call is successful, update the data
  //         toaster.push(<Message showIcon type='success' >
  //             Done Dana Dan.
  //         </Message>, { placement: 'topEnd' });
  //     }
  // }
  //////// Product Register Attributes End ////////
  const renderField = (fieldName, labelValue) => (
    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
      {isEditing ? (
        <Input value={labelValue} onChange={value => handleInputChange(fieldName, value)} />
      ) : (
        <span>{labelValue}</span>
      )}
    </FlexboxGrid.Item>
  );

  ////////// controls /////////

  const [fileInfo1, setFileInfo1] = useState({
    PPT_coverpage: null,
    PPT_footerpage: null,
    PDF_coverpageH: null,
    PDF_footerpageH: null,
    PDF_coverpageV: null,
    PDF_footerpageV: null,
    excel_banner: null
  });
  const [companyid, setCompanyid] = useState(0);
  const [aliasShort, setAliasShort] = useState(null);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details?populate=*`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      const extractedid = json.data[0].id;
      setAliasShort(json.data[0].attributes.AliasShort);
      setFileInfo1(prev => ({
        ...prev,
        PPT_coverpage: `${ip}${
          json.data[0]?.attributes?.PPT_coverpage?.data?.attributes?.url ?? ''
        }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        PPT_footerpage: `${ip}${
          json.data[0]?.attributes?.PPT_footerpage?.data?.attributes?.url ?? ''
        }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        PDF_coverpageH: `${ip}${
          json.data[0]?.attributes?.PDF_coverpageH?.data?.attributes?.url ?? ''
        }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        PDF_footerpageH: `${ip}${
          json.data[0]?.attributes?.PDF_footerpageH?.data?.attributes?.url ?? ''
        }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        PDF_coverpageV: `${ip}${
          json.data[0]?.attributes?.PDF_coverpageV?.data?.attributes?.url ?? ''
        }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        PDF_footerpageV: `${ip}${
          json.data[0]?.attributes?.PDF_footerpageV?.data?.attributes?.url ?? ''
        }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        excel_banner: `${ip}${json.data[0]?.attributes?.excel_banner?.data?.attributes?.url ?? ''}`
      }));
      setCompanyid(extractedid);
      setStatus(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  const handleControls = async currentStatus => {
    try {
      const updatedStatus = !currentStatus; // Toggle the status
      const updatedStatus1 = currentStatus; // Toggle the status
      await updateControls(updatedStatus);
      await forsizeUnit(updatedStatus1);
      await forsizerange(updatedStatus);
      fetchDatacompany();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  const updateControls = async newStatus => {
    try {
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          FreeSize: newStatus
        })
      );
      await fetch(`${ip}/api/company-details/${companyid}`, {
        method: 'PUT',
        body: formData
      });
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const forsizeUnit = async newStatus => {
    try {
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          status: newStatus
        })
      );
      await fetch(`${ip}/api/product-attributes/14`, {
        method: 'PUT',
        body: formData
      });

      fetchDataHeads();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };
  const forsizerange = async newStatus => {
    try {
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          status: newStatus
        })
      );
      await fetch(`${ip}/api/product-attributes/15`, {
        method: 'PUT',
        body: formData
      });
      fetchDataHeads();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  /////// for Catalogue CoverImagess //////
  const [cdata, setCdata] = useState();
  const [bloading, setBloading] = useState(false);
  const url = `${ip}/api/company-details/${companyid}`;
  const submit = async e => {
    e.preventDefault();
    setBloading(true);
    const formData = new FormData();
    if (cdata.PPT_coverpage) {
      formData.append('files.PPT_coverpage', cdata.PPT_coverpage);
    }
    if (cdata.PPT_footerpage) {
      formData.append('files.PPT_footerpage', cdata.PPT_footerpage);
    }
    if (cdata.PDF_coverpageH) {
      formData.append('files.PDF_coverpageH', cdata.PDF_coverpageH);
    }
    if (cdata.PDF_footerpageH) {
      formData.append('files.PDF_footerpageH', cdata.PDF_footerpageH);
    }
    if (cdata.PDF_coverpageV) {
      formData.append('files.PDF_coverpageV', cdata.PDF_coverpageV);
    }
    if (cdata.PDF_footerpageV) {
      formData.append('files.PDF_footerpageV', cdata.PDF_footerpageV);
    }
    if (cdata.excel_banner) {
      formData.append('files.excel_banner', cdata.excel_banner);
    }
    formData.append('data', JSON.stringify(cdata));
    fetch(url, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        // Refresh page after 2 seconds (2000 milliseconds)
        toaster.push(
          <Message showIcon type="success">
            Saved Successfully
          </Message>,
          { placement: 'topEnd' }
        );
        setBloading(false);
      })
      .catch(error => {
        console.error(error);
        alert('Something went wrong. Please try again');
      });
  };

  const handleImageUpload = (fileList, key) => {
    if (fileList.length > 0) {
      const lastIndex = fileList.length - 1;
      const file = fileList[lastIndex];
      const allowedExtensions = ['jpg', 'jpeg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (allowedExtensions.includes(fileExtension)) {
        setCdata({
          ...cdata,
          [key]: file.blobFile
        });
        toaster.push(
          <Message showIcon type="success">
            Image Upload Successfully
          </Message>,
          { placement: 'topCenter' }
        );
        // setNum(1);
        // Only set fileInfo if the file is of the allowed format
        previewFile(file.blobFile, value => {
          setFileInfo1(prev => ({ ...prev, [key]: value }));
        });
      } else {
        toaster.push(
          <Message showIcon type="error">
            Please Change Image should be jpg/jpeg
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };
  const [openSet, setOpenSet] = useState(false);
  const handleSelectChange = async (selectedOption) => {
    setAliasShort(selectedOption); // Update the selected value in the state
  
    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${companyid}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: { AliasShort: selectedOption }, // Save the selected option
          }),
        }
      );
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      console.log("Update successful");
    } catch (error) {
      console.error("Error updating AliasShort:", error);
      // Handle error if needed
    }
  };
  
  
  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar selection-head" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="row" alignItems="flex-start" spacing={90}>
                <h3 className="title">Attributes Master</h3>
                <div onClick={() => setOpenSet(!openSet)}>
                  <MenuIcon className="burgerMenu1" />
                  {/* <CloseIcon className='burgerMenu1'/> */}
                </div>
              </Stack>

              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Master</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            {/* <Button onClick={hsndleds}>save</Button> */}
            <Stack className={openSet ? 'mange-item' : 'mange-search'}>
              <Nav
                appearance="tabs"
                activeKey={activeKey}
                onSelect={handleNavSelect}
                style={{ display: 'flex', gap: '20px' }}
                className="mstr-nav"
              >
                <Nav.Item eventKey="content1">
                  <b>Product Attributes</b>
                </Nav.Item>
                <Nav.Item eventKey="content2">
                  <b>Catalogue Attributes</b>
                </Nav.Item>
                <Nav.Item eventKey="content3">
                  <b>Filters Master</b>
                </Nav.Item>
                <Nav.Item eventKey="content4">
                  <b>Controls</b>
                </Nav.Item>
              </Nav>
            </Stack>
          </Stack>
        </Stack>
        <Divider className="divide" />
        <div>
          <Panel className="settings-master">
            {activeKey === 'content1' && (
              <>
              <Stack justifyContent='space-between'>
                <Button appearance="subtle" active onClick={handleEditClick}>
                  {isEditing ? 'Close' : 'Edit'}
                </Button>
                <Stack className="setting-mstr-panel">
                  {isEditing && (
                    <Button
                      appearance="primary"
                      color="cyan"
                      onClick={handleSave}
                      className="mstr-btn-setting1"
                    >
                      Save
                    </Button>
                  )}
                </Stack>
                </Stack>
                <Table
                  // height={400}
                  data={attributes}
                  style={{ marginTop: '10px' }}
                  // autoHeight
                  bordered
                  cellBordered
                  height={tableHeight}
                >
                  <Column width={200} align="left" resizable>
                    <HeaderCell>
                      <b>Attributes</b>
                    </HeaderCell>
                    <Cell dataKey="attribute" />
                  </Column>

                  <Column width={300} align="left" resizable>
                    <HeaderCell>
                      <b>Your Caption</b>
                    </HeaderCell>
                    <Cell>
                      {rowData =>
                        isEditing ? (
                          <input
                            className="rs-input"
                            value={rowData.value}
                            onChange={e => handleInputChange(rowData.attribute, e.target.value)}
                            style={{ width: '100%', padding: '4px' }}
                          />
                        ) : (
                          <span>{rowData.value}</span>
                        )
                      }
                    </Cell>
                  </Column>
                  <Column width={400} align="center" resizable>
    <HeaderCell>
      <b>Settings</b>
    </HeaderCell>
    <Cell>
      {rowData =>
        rowData.attribute === 'AliasCode' ? (
         
          <SelectPicker
              data={[
                { label: 'Manual', value: 'Manual' },
                { label: 'Cate.Shortname + Auto', value: 'Cate.Shortname + Auto' },
                { label: 'Cate.Shortname + Manual', value: 'Cate.Shortname + Manual' },
              ]}
              value={aliasShort}
              onChange={async (value) => {
                await handleSelectChange(value);
              }}
              placeholder="Select Mode"
              style={{ width: 200, marginTop:'-8px' }}
            />
  
        ) : (
          <span>-</span> // Placeholder for other rows
        )
      }
    </Cell>
  </Column>
                </Table>
                
              </>
            )}
            {activeKey === 'content2' && (
              <Panel style={{ width: '50%', margin: 'auto' }} shaded>
                <Stack direction="column" alignItems="flex-start" className="mstr-panel1">
                  <Checkbox
                    checked={
                      headsData.length > 0 && headsData.every(head => head.attributes.status)
                    }
                    onChange={handleSelectAllChange}
                  >
                    <b>Select All</b>
                  </Checkbox>
                  <FlexboxGrid justify="space-between">
                    {filteredHeadsData.map(head => (
                      <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                        <Checkbox
                          key={head.id}
                          checked={head.attributes.status}
                          onChange={() => handleCheckboxChange(head.id, head.attributes.status)}
                        >
                          {displayLabels[head.attributes.Heads]}
                        </Checkbox>
                      </FlexboxGrid.Item>
                    ))}
                  </FlexboxGrid>
                </Stack>
              </Panel>
            )}
            {activeKey === 'content3' && (
              <>
                <p style={{ color: 'red', fontSize: '12px' }}>
                  You Can Choose only 3 Favourite Filter to show
                </p>
                <FlexboxGrid justify="start">
                  {fheadsData.map(head => (
                    <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                      <Checkbox
                        key={head.id}
                        checked={head.attributes.filterstatus}
                        onChange={() =>
                          handleCheckboxChange1(head.id, head.attributes.filterstatus)
                        }
                        disabled={checkedCount === 3 && !head.attributes.filterstatus}
                      >
                        {displayLabels1[head.attributes.FilterName]}
                      </Checkbox>
                    </FlexboxGrid.Item>
                  ))}
                </FlexboxGrid>
              </>
            )}
            {activeKey === 'content4' && (
              <>
                <Stack spacing={20} className="setting">
                  {status ? <label>Free Size</label> : <label>Size Unit</label>}
                  <Toggle checked={status} onChange={() => handleControls(status)} />
                   
                </Stack>
              </>
            )}
          </Panel>
        </div>
        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERPDaddy Software Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};

export default MasterAttri;
